export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [
      {
        id: 1,
        title: 'Support Team',
        body: 'Why not consider this a test message?',
        createdAt: '17 min ago'
      }
    ],
    notifications: [],
    tasks: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js